import * as React from "react";
import { Animate } from "..";
export class WrapWithAnimate extends React.Component {
    render() {
        return this.props.children && this.props.shouldWrap ?
            React.createElement(Animate, Object.assign({}, this.props), this.props.children) : this.props.children;
    }
}
//# sourceMappingURL=WrapWithAnimate.js.map